export default "__VITE_ASSET__Dlbk5uiR__"